import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import AttachmentIcon from 'styles/images/icons/fileUpload.svg';
import strings from 'strings';
import './fileUploader.scss';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ImageIcon from '@material-ui/icons/Image';

function getFileIcon(fileType) {
  if (!fileType) return <InsertDriveFileIcon style={{ color: 'var(--fg-tertiary)' }} />;
  if (fileType === 'application/pdf') return <PictureAsPdfIcon style={{ color: '#e53935' }} />;
  if (fileType.startsWith('image/')) return <ImageIcon style={{ color: 'var(--rox-lilac-ink)' }} />;
  return <InsertDriveFileIcon style={{ color: 'var(--fg-tertiary)' }} />;
}

export default function FileUploader({
  onFilesAccepted,
  onFilesRejected,
  selectedFiles = [],
  setSelectedFiles,
  accept,
  maxSize = 10485760,
  maxFiles = 1,
  multiple = false,
  disabled = false,
}) {
  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length && onFilesRejected) {
      onFilesRejected(rejectedFiles);
    }
    if (acceptedFiles.length && onFilesAccepted) {
      onFilesAccepted(acceptedFiles);
    }
    setSelectedFiles(acceptedFiles);
  }, [onFilesAccepted, onFilesRejected, setSelectedFiles]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    maxFiles,
    multiple,
    maxSize,
    disabled,
  });

  return (
    selectedFiles.length === 0 ? (
      <div className={`dropBox${disabled ? ' disabled' : ''}`} {...getRootProps()}>
        <input {...getInputProps()} />
        <img src={AttachmentIcon} alt="upload icon" />
        <div className="hint mt-2">{strings.APPLICANT.ATTACHMENTS.DRAG_AND_DROP}</div>
        <div className="hint">{strings.APPLICANT.ATTACHMENTS.SUPPORTED_FILE_25MB}</div>
      </div>
    ) : (
      <div className="file-card">
        <div className="file-info">
          {getFileIcon(selectedFiles[0].type)}
          <div className="file-details">
            <span className="file-name">{selectedFiles[0].name}</span>
            <div className="file-meta">
              <span className="file-size">{(selectedFiles[0].size / 1024).toFixed(2)}kb</span>
              <span className="file-status">Complete</span>
            </div>
          </div>
        </div>
        <HighlightOffOutlinedIcon
          className="del grey"
          style={{ color: 'var(--fg-tertiary)' }}
          onClick={e => {
            e.stopPropagation();
            setSelectedFiles([]);
          }}
        />
      </div>
    )
  );
}
